<template>
  <div>
    <v-card flat class="mb-5">
      <v-card-text>
        <v-list-item class="px-0">
          <v-list-item-content class="py-0">
            <v-row no-gutters>
              <v-col class="py-0" cols="12" md="5">
                <v-list-item class="px-0">
                  <v-list-item-avatar color="secondary">
                    <v-icon dark>mdi-home</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0 mt-3">
                    <div class="subtitle-2 black--text">
                      {{ $getDeepObj(initValue, 'detail.sekolah.data.nama') || '-' }}
                    </div>
                    <div class="caption">
                      <span>
                        <v-icon small left>mdi-map-marker</v-icon>
                        {{ $getDeepObj(initValue, 'detail.sekolah.data.alamat') || '-' }}
                      </span>
                      <br />
                      <span>
                        <v-icon small left>mdi-city</v-icon>
                        {{ $getDeepObj(initValue, 'detail.sekolah.data.m_jenjang.data.singkat') || '-' }}
                      </span>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col class="pt-0" cols="12" md="3">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0">
                    <v-list-item class="px-0">
                      <v-list-item-content class="py-0 mt-3">
                        <span class="caption">Kepala Sekolah</span>
                        <p class="ma-0">
                          <span>
                            {{ $getDeepObj(initValue, 'detail.ptk_kasek.data.nama') || '-' }}
                          </span>
                        </p>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
    </v-card>
    <v-card class="mx-auto" flat>
      <v-card-text class="pa-5">
        <v-container>
          <h2 class="secondary--text mb-3">Data Sekolah {{ (initValue && initValue.nama) || '' }}</h2>
          <v-row no-gutters class="my-5" v-if="!detail || (detail && !$isObject(detail))">
            <v-col md="4">
              <span class="secondary--text">Pengawas</span><br />
              <v-btn dark color="secondary" left @click="setSumber">
                <v-icon left>mdi-account</v-icon>
                Pilih Pengawas
              </v-btn>
            </v-col>
          </v-row>
          <v-list-item v-if="detail && $isObject(detail)" class="px-0 mb-3">
            <v-list-item-avatar color="secondary lighten-3" size="50">
              <v-icon dark style="font-size: 30px">mdi-account</v-icon>
            </v-list-item-avatar>
            <v-list-item-content class="py-0">
              <v-row no-gutters>
                <v-col cols="12" md="4">
                  <h2 class="body-1 secondary--text">
                    {{ $getDeepObj(detail, 'nama') || $getDeepObj(detail, 'ptk.data.nama') || '-' }}
                  </h2>
                  <div style="line-height: 1.2">
                    <label class="grey--text">No.UKG / SIMPKB-ID: </label>
                    {{ $getDeepObj(detail, 'ptk.data.no_ukg') || $getDeepObj(detail, 'ptk_id') }}
                  </div>
                </v-col>
                <v-col cols="12" md="8">
                  <v-btn dark color="secondary" left @click="setSumber">
                    <v-icon left>mdi-pencil</v-icon>
                    Ganti Pengawas
                  </v-btn>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-container>
      </v-card-text>
    </v-card>
    <component ref="sumber" :is="`sumber`" :type="type" :masters="masters" />
  </div>
</template>
<script>
import BaseFormGenerator from '@components/base/BaseFormGenerator';
export default {
  components: { BaseFormGenerator, Sumber: () => import('../component/Sumber') },
  props: {
    masters: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      required: true,
    },
    initValue: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: 'Lengkapi Data Formulir dibawah ini',
    },
  },
  data() {
    return {
      sumber: 1,
      form: {},
      detail: null,
      isEdit: false,
      id: '',
    };
  },
  computed: {
    configs() {
      const M_PROPINSI = this.masters.propinsi || {};
      const M_KOTA = this.masters.kota || {};
      const M_KECAMATAN = this.masters.kecamatan || {};
      return {
        selector: ['k_propinsi', 'k_kota', 'k_kecamatan'],
        required: ['k_propinsi', 'k_kota', 'k_kecamatan'],
        label: ['Provinsi', 'Kota/Kabupaten', 'Kecamatan'],
        options: [M_PROPINSI, M_KOTA, M_KECAMATAN],
        grid: [{ cols: 4 }, { cols: 4 }, { cols: 4 }],
      };
    },
  },

  mounted() {
    this.reset();
  },

  methods: {
    getValue() {
      this.$set(this.form, 'ptk_id', (this.detail && this.detail.ptk_id) || '');
      return this.form;
    },

    setSumber() {
      this.$refs.sumber.open('Pilih dari Daftar Pengawas').then((item) => {
        this.detail = item;
      });
    },

    reset() {
      this.$set(this, 'form', {});
      this.detail = null;
      this.isEdit = false;
      this.id = '';
      this.sumber = 1;
    },

    initForm(value) {
      this.isEdit = true;
      this.sumber = 1;
      this.detail = this.$getDeepObj(value, 'detail.psp_diklat_pengawases.data.0') || {};
      this.id = value && value.id;

      if (this.isEdit) {
        this.$set(this.form, 'ptk_id', (this.detail && this.detail.ptk_id) || '');
      }
    },

    changeSelect() {
      this.$set(this, 'detail', null);
    },
  },
  watch: {
    initValue: 'initForm',
  },
};
</script>
